import { useNavigate } from "react-router-dom";
import { Table, Paper, Text, Image, Anchor, Loader, Center, Button } from "@mantine/core";
import { useSelector } from "react-redux";
import useSWR, { mutate } from "swr";
import { USER_TYPES } from "../../../../utils/userTypes";
import { fetcher } from "../../../../services/fetcher";
import classes from "./QRCodeList.module.css";
import { successNotifications, errorNotifications } from "../../../../utils/handleNotifications";

const QRCodeList = ({ uuid }) => {
  const navigate = useNavigate();
  const operatorProfile = useSelector((state) => state.operatorProfile);
  const { user_type } = useSelector((state) => state.auth);

  // Updated endpoint logic
  const endpoint =
    user_type[0] === USER_TYPES.OPERATOR && operatorProfile?.uuid
      ? `operator/operator-links/${operatorProfile.uuid}`
      : uuid
      ? `operator/operator-links/${uuid}`
      : null;

  const packageEndpoint = `operator/packages`;

  const { data, error, isLoading } = useSWR(endpoint, fetcher);
  const { data: packages } = useSWR(packageEndpoint, fetcher);
  const packageMap = packages ? Object.fromEntries(packages.map((pkg) => [pkg.id, pkg.title])) : {};

  const BASE_URL = import.meta.env.VITE_API_ENDPOINT;

  const handleDelete = async (id) => {
    try {
      console.log(`Deleting QR Code with ID: ${id}`);
      await fetcher(`${endpoint}/${id}`, "DELETE");
      successNotifications("QR Code deleted successfully");
      mutate(endpoint);
    } catch (error) {
      console.error("Delete Error:", error);
      errorNotifications(error.response?.data || "An error occurred while deleting", error);
    }
  };

  if (isLoading) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  if (error) {
    console.error("Error fetching QR Codes:", error);
    return <Text color="red">Error loading QR codes</Text>;
  }

  return (
    <Paper p="xl" shadow="sm" withBorder>
      <Text className={classes.heading} mb="xl">
        Operator Link List
      </Text>
      <Table striped highlightOnHover>
        <thead>
          <tr>
            <th className={classes.styles}>Name</th>
            <th className={classes.styles}>Package Name</th>
            <th className={classes.styles}>Expiration Date</th>
            <th>QR Code</th>
            <th className={classes.styles}>Link</th>
            <th className={classes.styles}>Download</th>
            <th className={classes.styles}>Edit</th>
            <th className={classes.styles}>Delete</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => (
            <tr key={item.id}>
              <td className={classes.name}>{item.name}</td>
              <td className={classes.fields}>{packageMap[item.package]}</td>
              <td className={classes.fields}>{new Date(item.expiration_date).toLocaleString()}</td>
              <td className={classes.styles}>
                <Image src={`${BASE_URL}${item.qr_code}`} alt={`QR Code for ${item.name}`} height={60} width={40} />
              </td>
              <td className={classes.fields}>
                <Anchor href={item.link} target="_blank" rel="noopener noreferrer">
                  Open Link
                </Anchor>
              </td>
              <td>
                <Button component="a" href={`${BASE_URL}${item.qr_code}`} download size="xs">
                  Download
                </Button>
              </td>
              <td>
                <Button
                  size="xs"
                  onClick={() => navigate(`/operator/operators/${operatorProfile?.uuid || uuid}/qr-code/add`, {
                    state: { editData: item },
                  })}
                >
                  Edit
                </Button>
              </td>
              {/* <Button
                size="xs"
                onClick={() => {
                  console.log("Button Clicked");

                  console.log("User Type:", user_type);
                  console.log("First User Type Value:", user_type?.[0]); // Check if user_type[0] exists
                  console.log("Expected User Type:", USER_TYPES.OPERATOR);
                  console.log("Condition Check:", user_type?.[0] === USER_TYPES.OPERATOR);

                  const finalUuid = user_type?.[0] === USER_TYPES.OPERATOR ? operatorProfile?.uuid : uuid;

                  console.log("Operator Profile:", operatorProfile);
                  console.log("Operator UUID:", operatorProfile?.uuid);
                  console.log("Props UUID:", uuid);
                  console.log("Final UUID Used:", finalUuid);

                  if (!finalUuid) {
                    console.error("UUID is missing, cannot navigate to edit page.");
                    return;
                  }

                  navigate(`/operators/${finalUuid}/qr-code/add`, {
                    state: { editData: item },
                  });
                }}
              >
                Edit
              </Button> */}
              <td>
                <Button size="xs" color="red" onClick={() => handleDelete(item.id)}>
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Paper>
  );
};

export default QRCodeList;